import gql from 'graphql-tag';
import {
    EVENT_FORM_FRAGMENT,
    GUIDE_FRAGMENT,
    GUIDE_VIEW_FRAGMENT,
    G_EXTERNAL_POINT_FRAGMENT
} from 'graphql/fragment/guideFragment';

export const GUIDE_QUERY = gql`
    query GuideQuery($guideId: String!, $token: String) {
        guide(guideId: $guideId, token: $token) {
            ...GGuide
        }
    }

    ${GUIDE_FRAGMENT}
`;

export const GUIDE_QUERY_VIEW = gql`
    query GuideQueryView($guideIdOrPath: String!, $token: String, $language: String) {
        guideView(guideIdOrPath: $guideIdOrPath, token: $token, language: $language) {
            ...GGuideView
        }
    }

    ${GUIDE_VIEW_FRAGMENT}
`;

export const CURRENT_USER_GUIDES_QUERY = gql`
    query GuidesForCurrentUserQuery {
        currentUserGuides {
            guideId
            title
            guideType
            customPath
            worldMapId
        }
    }
`;

export const GUIDES_BY_ID_QUERY = gql`
    query GuideByIdQuery($guideId: String!, $token: String) {
        guideById(guideId: $guideId, token: $token) {
            guideId
            title
            guideType
            customPath
            worldMapId
        }
    }
`;

export const FORMS_CURRENT_USER_QUERY = gql`
    query CurrentUserForms {
        currentUserForms {
            title
            eventFormId
        }
    }
`;

export const FORM_CURRENT_USER_QUERY = gql`
    query CurrentUserForm($eventFormId: String!) {
        currentUserForm(eventFormId: $eventFormId) {
            ...EEventForm
        }
    }

    ${EVENT_FORM_FRAGMENT}
`;

export const FORM_SUBMISSIONS_QUERY = gql`
    query FormSubmissions($eventFormId: String!) {
        formSubmissions(eventFormId: $eventFormId) {
            eventForm {
                title
            }
            headers
            rows
        }
    }
`;

export const GUIDE_USERS_FOR_NOTIFICATION_QUERY = gql`
    query GuideUsersForNotificationQuery($guideId: String!) {
        eventUsersforTestNotifications(guideId: $guideId) {
            userId
            email
        }
    }
`;

export const EVENT_NETWORKING_TOPICS_QUERY = gql`
    query EventNetworkingTopicsQuery($eventId: String!) {
        guideView(guideIdOrPath: $eventId) {
            guideId
            networkingTopics {
                guideNetworkingTopicId
                questionTitle
                options {
                    title
                    optionId
                }
            }
        }
    }
`;

export const EVENT_USER_INFORMATION_BY_TOKEN_QUERY = gql`
    query EventUserInformationByTokenQuery($eventId: String!, $userId: String!, $token: String!) {
        e_userInformation_useToken(eventId: $eventId, userId: $userId, token: $token) {
            firstName
            lastName
            companyName
            jobPosition
            publicDescription
            linkedIn
            websiteUrl
            photoUrl
            networkingTopicOptionIds
        }
    }
`;

export const SEARCH_EXTERNAL_POINTS = gql`
    query ExternalPointsSearch($term: String!) {
        externalPointSearch(term: $term) {
            ...GExternalPoint
        }
    }

    ${G_EXTERNAL_POINT_FRAGMENT}
`;
